import { Card as CardMantine } from '@mantine/core'
import styled from 'styled-components'

export const Card = styled(CardMantine)`
  .mantine-Button-label {
    font-size: 14px;
  }

  background-color: ${({ theme }) => theme.cor27} !important;
  color: ${({ theme }) => theme.cor49} !important;
  border: 0px !important;
`